// extracted by mini-css-extract-plugin
export default {"error_block":"ErrorBlock_error_block__RANag","icon":"ErrorBlock_icon__hJMqU","content":"ErrorBlock_content__bLpar"};